import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppWeightUpdatePage } from './app-weight-update';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    AppWeightUpdatePage,
  ],
  imports: [
    IonicPageModule.forChild(AppWeightUpdatePage),
    PipesModule,
  ],
})
export class AppWeightUpdatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-weight-update/app-weight-update.module.ts